export default "__VITE_ASSET__Buiyb7FL__"